var invalid_fields = {};
var error_fields = {
  first_name: 'First name',
  last_name: 'Last name',
  number: 'Credit Card number',
  month: 'Expiration Month',
  year: 'Expiration Year',
  cvv: 'CVV',
};

function clear_errors() {
  invalid_fields = {};
}

function error (err, form) {
  $.each(err.fields, function(i, field) {
    if(typeof invalid_fields[field] === 'undefined') {
      invalid_fields[field] = field;
    }
  });

  var errors_markup = $.map(invalid_fields, function (field) {
    return '<li>' + error_fields[field] || field + '</li>';
  }).join('');

  form.find('.payment-errors').show()
  form.find('.payment-errors ul').empty().append(errors_markup);
  form.find('input[type=submit]').removeClass('disabled').removeAttr('disabled');
  form.find('button[type=submit]').removeClass('processing');
}


var paymentFormSubmit = function(){
  $('#payment-form').submit(function(event) {
    var form = $(this);
    event.preventDefault();
    form.find('input[type=submit]').prop('disabled', true);

    recurlyResponseHandler(form)

    return false;
  });
}

paymentFormSubmit();

var recurlyResponseHandler = function(form){
  clear_errors()

  recurly.token(form, function (err, token) {
    if (err) {
      error(err, form)
    } else {
      // recurly.js has filled in the 'token' field, so now we can submit the
      // form to your server; alternatively, you can access token.id and do
      // any processing you wish
      if($('#payment-form').get(0).getAttribute('data-remote')=="true")
      {
        $.post( $('#payment-form').get(0).getAttribute('action'), $('#payment-form').serialize() );
      }
      else{
        // and re-submit
        form.get(0).submit();
      }
    }
  });
}
